module.exports = __webpack_public_path__ + "img/71.db163759.jpg";